import './social_content_context_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.SocialContentPreviousCommentsView extends Monitoring.Views.SocialContentContextView

  initialize: (@options = {}) ->
    super(@options)
    @$resultsContainer = @$el.find('#previous_comments')

  noResultsMessage: ->
    'NO PREVIOUS COMMENTS FOUND'

  formatResults: ->
    amountReceived = @$resultsContainer.find('section').length
    maxAmountToShow = @searchQuery.getContextLimit()
    if (amountReceived - 1) > maxAmountToShow # minus one because central content should not be counted
      @$resultsContainer.find('section:first').remove()
      @$resultsContainer.before(@moreContextLinkHtml())
    @$resultsContainer.find('section:last').addClass('highlighted')
    @$resultsContainer.find('section:last').get(0).scrollIntoView()
    super()

  addOneToTheEnd: (socialContent, allTags, container=@$resultsContainer) =>
    @addOne(socialContent, allTags, (element) => container.prepend(element))

  addDates: ->
    dateTo = Date.create(@socialContent.created_at()).getTime()
    dateFrom = dateTo - (1000 * 60 * 60 * 24 * 365 * 2)
    # 2 years ago. The ideal would be the created_at of the parent post

    @searchQuery.addDateTo(dateTo)
    @searchQuery.addDateFrom(dateFrom)
